// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"86677ff4","239":"7c04e96f","451":"dc52dbec","455":"a51146a5"}[chunkId] + ".chunk.js";
};